import { compose, curry, join, reduce, startsWith, toPairs } from 'lodash/fp';

export const interpolateUrl = curry((pathTemplate: string, params: { [key: string]: string }) =>
    compose(
        reduce((mem, [key, val]) => mem.replace(':' + key, val), pathTemplate),
        toPairs
    )(params)
);

export const prependAppPath = (p: string) => join('', ['/app', startsWith('/', p) ? '' : '/', p]);

export const interpolateAppUrl = curry((pathTemplate: string, params: { [key: string]: string }) =>
    compose(prependAppPath, interpolateUrl)(pathTemplate, params)
);
